// extracted by mini-css-extract-plugin
export var active = "styles-module--active--DcGvE";
export var brand = "styles-module--brand--IGI4O";
export var githubLogo = "styles-module--githubLogo--X7Cx5";
export var navBar = "styles-module--navBar--TcxRD";
export var navItems = "styles-module--navItems--uOPk4";